import { fetch } from 'utils/redux/action'

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_MOSTWANTED = 'FETCH_MOSTWANTED'
export const RECEIVE_MOSTWANTED = 'RECEIVE_MOSTWANTED'

// ------------------------------------
// Actions
// ------------------------------------
export const actionTypes = {
	fetch: FETCH_MOSTWANTED,
	receive: RECEIVE_MOSTWANTED
}

// ------------------------------------
// Thunk
// ------------------------------------
export const fetchMostWanted = () => fetch('mostWanted', 'mostwanted', actionTypes)
